import clsx from 'clsx';

export const statusColors = {
  Atrasado: 'bg-waiting',
  Pago: 'bg-success',
  'Pago com créditos': 'bg-success',
  Feito: 'bg-success',
  Cancelado: 'bg-error',
  Pendente: 'bg-pending',
};

type StatusLabelProps = {
  status: keyof typeof statusColors;
};

export function StatusLabel({ status }: StatusLabelProps) {
  return (
    <div
      className={clsx(
        'flex items-center justify-center',
        'w-32 h-9 rounded-full',
        'text-xs font-bold m-auto',
        {
          'text-white': status !== 'Pendente',
        },
        statusColors[status]
      )}
    >
      {status}
    </div>
  );
}
